// extracted by mini-css-extract-plugin
module.exports = {"teslaCoil":"teslaCoil_teslaCoil__yIBvN","circle":"teslaCoil_circle__kj0GK","ifFalse":"teslaCoil_ifFalse__40DEM","ifTrue":"teslaCoil_ifTrue__5ayLu"};